import { createFileRoute } from '@tanstack/react-router';

import { AboutPageContent } from '~/components/about/AboutPageContent';

const AboutPage = () => {
  return <AboutPageContent />;
};

export const Route = createFileRoute('/$locale/about')({
  component: AboutPage,
});
